import React from 'react';

interface GappedLineDividerProps {
  totalWidth?: string;
  lineColor?: string;
  lineHeight?: string;
  gapWidth?: string;
  sideWidth?: string;
}

const GappedLineDivider: React.FC<GappedLineDividerProps> = ({
  totalWidth = '100%',
  lineColor = '#f0f0f0',
  lineHeight = '2px',
  gapWidth = '5px',
  sideWidth = '198px'
}) => {
  return (
    <div style={{ width: totalWidth, display: 'flex', alignItems: 'center', marginBottom: 2 }}>
      <div style={{ width: sideWidth, height: lineHeight, backgroundColor: lineColor }} />
      <div style={{ width: gapWidth }} />
      <div style={{ flex: 1, height: lineHeight, backgroundColor: lineColor }} />
      <div style={{ width: gapWidth }} />
      <div style={{ width: sideWidth, height: lineHeight, backgroundColor: lineColor }} />
    </div>
  );
};

export default GappedLineDivider;
